import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import loaderAnimation from './circular-loader.json';
import './style.scss';

interface AcCircularLoaderProps {
  text?: string;
  animationUrl?: string;
}

export const AcCircularLoader: React.FC<AcCircularLoaderProps> = ({ text, animationUrl }) => {
  return (
    <div className={'ac-circular-loader'} data-testid='storeCircularLoader'>
      <Player
        className={'ac-circular-loader__animation'}
        autoplay
        loop
        src={animationUrl || loaderAnimation}
      />
      {text && <span>{text}</span>}
    </div>
  );
};
